import { addProductBoxTranslationKeys } from '@ori/product-box';
export var BasicTranslationKeys;
(function (BasicTranslationKeys) {
  BasicTranslationKeys["Added"] = "Added";
  BasicTranslationKeys["Buy"] = "Buy";
  BasicTranslationKeys["Choose"] = "Choose";
  BasicTranslationKeys["InclusiveOfAllTaxes"] = "Inclusive Of All Taxes";
  BasicTranslationKeys["ReplaceWith"] = "Replace with";
  BasicTranslationKeys["Reserve"] = "Reserve";
  BasicTranslationKeys["Save"] = "Save";
  BasicTranslationKeys["SeeAllXReviews"] = "SeeAllXReviews";
  BasicTranslationKeys["lowestPriceText"] = "Our lowest price, the last 30 days before current price, was";
})(BasicTranslationKeys || (BasicTranslationKeys = {}));
export var TranslationKeys = addProductBoxTranslationKeys(BasicTranslationKeys);